export default __webpack_public_path__ + "static/media/aakash-anthe-logo.dee35014.png";